import { render, staticRenderFns } from "./PaginaVenditori.vue?vue&type=template&id=ede70870&"
import script from "./PaginaVenditori.vue?vue&type=script&lang=js&"
export * from "./PaginaVenditori.vue?vue&type=script&lang=js&"
import style0 from "./PaginaVenditori.vue?vue&type=style&index=0&id=ede70870&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports